var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabsNavIconFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2991 10.9458L12.5058 8.36417C12.4866 8.3275 12.4641 8.29417 12.4366 8.265L11.0958 6.33667C10.8033 5.91667 10.6483 5.42 10.6483 4.9V1.25H11.075C11.42 1.25 11.7 0.97 11.7 0.625C11.7 0.28 11.42 0 11.075 0H3.78744C3.44244 0 3.16244 0.28 3.16244 0.625C3.16244 0.97 3.44244 1.25 3.78744 1.25H4.21494V4.90833C4.21494 5.42333 4.06161 5.9175 3.77161 6.33833C2.98161 7.47917 1.76244 9.2375 0.586609 10.9292C-0.114225 11.9408 -0.191725 13.1958 0.379109 14.2867C0.949109 15.375 2.02328 16.0258 3.24911 16.0258L11.6258 16.0417C12.8583 16.0417 13.9358 15.39 14.5075 14.2967C15.0783 13.2075 15 11.955 14.2991 10.9458Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabsNavIconFlask);
export default __webpack_public_path__ + "static/media/labs_nav_icon_flask.4213239953d7fd641c62f4ca21d4ee89.svg";
export { ForwardRef as ReactComponent };